import { useMutation } from '@apollo/client'
import { VALID_AND_CREATE_NEW_RESULT_TASK } from './types'

export const useValidAndCreateNewResultTask = () => useMutation(VALID_AND_CREATE_NEW_RESULT_TASK)
